import { render, staticRenderFns } from "./form-colorpicker.vue?vue&type=template&id=9f48d94a&"
import script from "./form-colorpicker.vue?vue&type=script&lang=js&"
export * from "./form-colorpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports